import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

const RelativeTime = ({ mins }) => {
  if (mins === 0) {
    return '';
  }

  const formatter = Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });

  if (mins >= 120) {
    return ` (${formatter.format(mins / 60)} hours)`;
  }

  return ` (${mins} mins)`;
};

export default function ({ user, start, end }) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.workingHours}
      params={[user, start, end]}
      defaultData={{ under: { count: 0, sum: 0 }, over: { count: 0, sum: 0 } }}
      render={(loading, { under, over, days }) => (
        loading ? (
          <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />
        ) : (
          <>
            <div>
              <span className={under.count > 0 ? 'text-danger' : ''}>
                {under.count}
              </span>

              {' '}
              <span className="text-muted small">
                {`/${days}`}
                {under.count === 1 ? ' day' : ' days'}
                {' '}
                under
                <RelativeTime mins={under.sum} />
              </span>
            </div>

            <div>
              <span className={over.count > 0 ? 'text-danger' : ''}>
                {over.count}
              </span>
              {' '}
              <span className="text-muted small">
                {`/${days}`}
                {over.count === 1 ? ' day' : ' days'}
                {' '}
                over
                <RelativeTime mins={over.sum} />
              </span>
            </div>
          </>
        )
      )}
    />
  );
}
